import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevron-down.svg';
import { PartnerType } from 'models/partner.model';
import { apiService } from 'utils/api';

type Props = {
  partnerId: string;
  setPartnerId: (arg: string) => void;
};

const PartnerSelector: FC<Props> = ({ partnerId, setPartnerId }) => {
  const [allPartners, setAllPartners] = useState([] as PartnerType[]);
  const [filteredPartners, setFilteredPartners] = useState([] as PartnerType[]);
  const [selectedPartner, setSelectedPartner] = useState({} as PartnerType);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [loading, setLoading] = useState(true);

  const loadPartners = async () => {
    setLoading(true);
    const partners = await apiService.post('logistics/delivery-partner', {
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    setAllPartners(partners.data.delivery_partners);
    setFilteredPartners(partners.data.delivery_partners);
    setLoading(false);
  };

  useEffect(() => {
    loadPartners();
  }, []);

  useEffect(() => {
    setPartnerId(selectedPartner.id ?? '');
    setOpenDropdown(false);
  }, [selectedPartner]);

  useEffect(() => {
    setOpenDropdown(false);
  }, [partnerId]);

  useEffect(() => {
    if (!openDropdown) setFilteredPartners(allPartners);
  }, [openDropdown]);

  const filterSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    const filtered = allPartners.filter(({ name }) => name.toLowerCase().includes(searchValue));
    setFilteredPartners(filtered);
  };

  return (
    <Dropdown
      visible={openDropdown}
      onClickOutside={() => setOpenDropdown(false)}
      content={
        <div
          onClick={() => setOpenDropdown(!openDropdown)}
          className='px-3 py-[6px] inline-flex items-center text-sm font-medium rounded-[20px] bg-red-1'>
          {selectedPartner.name ?? 'All Partners'}
          <ChevronDownIcon />
        </div>
      }>
      <DropdownList className='min-w-[300px]'>
        <div className='px-5 border-b border-b-[#ebebeb] border-dashed'>
          <Input
            type='search'
            inputClass='py-2 text-sm'
            placeholder='Search partner'
            small
            onChange={filterSearch}
          />
        </div>
        <ul className='max-h-[300px] overflow-auto'>
          <DropdownItem>
            <Input
              type='radio'
              className='text-sm'
              checked={!partnerId}
              onChange={() => setSelectedPartner({} as PartnerType)}
              label='All Partners'
            />
          </DropdownItem>
          {loading ? (
            <DropdownItem isLabel>Loading...</DropdownItem>
          ) : (
            filteredPartners.map((p, i) => (
              <DropdownItem key={i}>
                <Input
                  className='text-sm'
                  type='radio'
                  checked={partnerId === p.id}
                  onChange={() => setSelectedPartner(p)}
                  label={p.name}
                />
              </DropdownItem>
            ))
          )}
        </ul>
      </DropdownList>
    </Dropdown>
  );
};

export default PartnerSelector;
